import {
	Component,
	ElementRef,
	Input,
	QueryList,
	ViewChild,
	ViewChildren,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgScrollbar } from 'ngx-scrollbar';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { IUser } from 'user/user';
import { IUserUsageStats } from 'user/user-usage-stats';

import { AppChatController } from './app-chat.controller';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { ChatMessageModel } from './chat-message/chat-message.model';

@Component({
	selector: 'spr-app-chat',
	templateUrl: './app-chat.component.html',
	host: {
		class:
			'right-0 bottom-0 flex fixed items-stretch ' +
			'flex-col bg-white z-30 p-shadow',
	},
})
export class AppChatComponent {
	@ViewChild(NgScrollbar, { static: true })
	public scroller: NgScrollbar;

	@Input() public showToggleButton: boolean;

	public message: string;
	public visioUrl: SafeResourceUrl;
	public sessionUser$: Observable<IUser>;
	public participants$: Observable<IUser[]>;
	public messages$: Observable<ChatMessageModel[]>;
	public userUsageStats$: Observable<IUserUsageStats>;

	constructor(
		private _el: ElementRef,
		private _sanitizer: DomSanitizer,
		private _controller: AppChatController
	) {
		this.userUsageStats$ = _controller.userUsageStats$;
		this.participants$ = _controller.participants$;
		this.sessionUser$ = _controller.sourceUser$;
		this.messages$ = _controller.messages$;
	}

	private _user: IUser;

	public get user(): IUser {
		return this._user;
	}

	@Input()
	public set user(user: IUser) {
		this._controller.updateUserId(user.id);
		this._user = user;
	}

	@ViewChildren(ChatMessageComponent)
	public set messageViews(queryList: QueryList<ChatMessageComponent>) {
		if (!queryList.last) {
			return;
		}
		this.scroller.scrollToElement(queryList.last.el);
	}

	public onChatGoBack() {
		this._controller.closeChat();
	}

	public onCollapseClick() {
		this._controller.toggleChat();
	}

	public onMessageSubmit() {
		if (!this.message) {
			return;
		}

		this._controller.sendMessage(this.message);
		this.message = '';
	}

	public trackByMessage(index: number, message: ChatMessageModel) {
		return message.message.id;
	}

	public startVisio() {
		this._controller.startVisio(this.message);
	}

	public stopVisio() {
		this.visioUrl = null;
	}

	public onVisioOpen(sessionId: string, user: IUser) {
		this.visioUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
			`${environment.visioWebsiteUrl}?sessionId=${sessionId}&userName=${user.name}`
		);
	}
}
